// removed by extract-text-webpack-plugin
module.exports = {"spaceWrap":"_3oVOIf8CoCdiG7xmR0XPUX","banner":"X4NGXvxOcgk86KArfLMM4"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicPlansGotBetterBanner.scss
// module id = 2877
// module chunks = 0